// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"59":"e0cd3d57","79":"b870d68d","343":"d338e89d","429":"22f94eca","482":"696532fb","714":"9968bd36","871":"5415eb1c"}[chunkId] + ".chunk.js";
};